import React from "react";
class Contacts extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="sectionTitle blueTitleBg clearfix d-flex">
                                <h2 class="m-0 float-left mr-auto px-3">Contact Details</h2>
                            </div>
                            <ul class="contactInfo bg-light p-3 list-unstyled shadow-sm">
                                <li class="border-bottom py-2">
                                    <strong class="d-block">Editorial</strong>
                                    <a href="mailto:editor@newageislam.com" title="editor@newageislam.com">editor@newageislam.com</a>
                                    </li>
                                    <li class="border-bottom py-2">
                                    <strong class="d-block">Article Submissions</strong>
                                    <a href="mailto:submissions@newageislam.com" title="submissions@newageislam.com">submissions@newageislam.com</a> /
                                    <a href="mailto:editor@newageislam.com" title="editor@newageislam.com">editor@newageislam.com</a><br />
                                    (See) <a href="/NewAgeIslamSubmissionguidlines/" title="Submissions Policy" target="_blank">Submissions Policy</a>
                                </li>
                                <li class="border-bottom py-2">
                                    <strong class="d-block">Website</strong>
                                    For problems with subscriptions or withdrawing subscriptions 
                                    <a href="mailto:webmaster@newageislam.com" title="webmaster@newageislam.com">webmaster@newageislam.com</a> / 
                                    <a href="mailto:info@newageislam.com" title="info@newageislam.com">info@newageislam.com</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="sectionTitle redTitleBg clearfix d-flex">
                                <h2 class="m-0 float-left mr-auto text-uppercase px-3">Send Enquiry</h2>
                            </div>
                            <div class="contactForm bg-light p-3 clearfix shadow-sm">
                                <form>
                                    <div class="form-group">
                                        <input type="text" placeholder="Name" class="form-control rounded-0" />
                                    </div>
                                    <div class="form-group">
                                        <input type="email" placeholder="Email" class="form-control rounded-0" />
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Subject" class="form-control rounded-0" />
                                    </div>
                                    <div class="form-group">
                                        <textarea type="text" placeholder="Your Message" class="form-control rounded-0"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <input value="Send Enquiry" type="submit" class="btn btn-danger border-0 rounded-0 px-4 float-right" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default Contacts;